/**
 * 自社区分カテゴリー
 */
export const CompanyTypeCode = {
  NPO: 'npo',
  UNIVERSITY: 'university',
  OVERSEAS_STARTUP: 'overseas_startup',
  PARTNERSHIP_WITHIN_6_MONTHS: 'partnership_within_6_months',
  LOCAL_CHALLENGE_COMPANY: 'local_challenge_company',
  PARTNERSHIP_WITHIN_3_MONTHS: 'partnership_within_3_months',
  ACADEMIA_STARTUP: 'academia_startup',
  OVERSEAS_CAPITAL: 'overseas_capital',
  PUBLIC_COMPANY: 'public_company',
  LOCAL_GOVERNMENT: 'local_government',
  LARGE_ENTERPRISE: 'large_enterprise',
  MEDIUM_SMALL_ENTERPRISE: 'medium_small_enterprise',
  STARTUP: 'startup',
  OTHER_ORGANIZATION: 'other_organization',
} as const

export type CompanyTypeCodeValue =
  (typeof CompanyTypeCode)[keyof typeof CompanyTypeCode]

export const CompanyTypeLabel: { [key: string]: string } = {
  [CompanyTypeCode.NPO]: '非営利団体／市民活動団体',
  [CompanyTypeCode.UNIVERSITY]: '大学・研究機関',
  [CompanyTypeCode.OVERSEAS_STARTUP]: '海外スタートアップ',
  [CompanyTypeCode.PARTNERSHIP_WITHIN_6_MONTHS]: '半年以内に連携を希望している組織',
  [CompanyTypeCode.LOCAL_CHALLENGE_COMPANY]: '地方発の挑戦企業',
  [CompanyTypeCode.PARTNERSHIP_WITHIN_3_MONTHS]: '直近3ヶ月以内に連携意向あり',
  [CompanyTypeCode.ACADEMIA_STARTUP]: 'アカデミア発スタートアップ',
  [CompanyTypeCode.OVERSEAS_CAPITAL]: '海外資本企業',
  [CompanyTypeCode.PUBLIC_COMPANY]: '公開企業（上場企業）',
  [CompanyTypeCode.LOCAL_GOVERNMENT]: '地方自治体',
  [CompanyTypeCode.LARGE_ENTERPRISE]: '大企業',
  [CompanyTypeCode.MEDIUM_SMALL_ENTERPRISE]: '中堅・中小規模企業',
  [CompanyTypeCode.STARTUP]: 'スタートアップ企業',
  [CompanyTypeCode.OTHER_ORGANIZATION]: 'その他の団体・組織',
}

export const CompanyTypeValues = Object.entries(CompanyTypeLabel).map(
  ([code, value]) => ({
    code,
    value,
  })
)
